import { createTheme } from '@mui/material/styles';

export const GreenTheme = createTheme({
    palette: {
        mode: 'light', // Tema claro
        primary: {
            main: '#81C784', // Verde claro
            contrastText: '#FFFFFF', // Branco para contraste
        },
        secondary: {
            main: '#4CAF50', // Verde médio, um pouco mais forte
            contrastText: '#FFFFFF', // Branco
        },
        background: {
            default: '#E8F5E9', // Fundo claro, verde suave
            paper: '#C8E6C9', // Papel verde claro
        },
        text: {
            primary: '#388E3C', // Verde escuro para o texto principal
            secondary: '#66BB6A', // Verde suave para texto secundário
            disabled: '#A5D6A7', // Verde claro para textos desabilitados
        },
        divider: '#4CAF50', // Verde médio para o divisor
    },
});
